const status = {
  IDLE: 1,
  LOADING: 2,
  SUCCESS: 3,
  ERROR: 4
}

const sessionStatus = {
  NEW: 0,
  COACH_ACCEPTED: 1,
  COACHEE_ACCEPTED: 2,
  BOTH_ACCEPTED: 3,
  REJECTED: 4
}

const coachingStatus = {
  NEW: 'new',
  PENDING: 'approval',
  ACTIVE: 'active',
  FINISHED: 'terminated',
  RATED: 'finalized',
  ARCHIVED: 'archived',
  CLOSED: 'closed'
}

const groups = {
  PUBLIC: 'public',
  NEW: 'new_user',
  ADMIN: 'administrators',
  COACH: 'coaches',
  COACHEE: 'coachees'
}

const defaultRoute = {
  [groups.PUBLIC]: 'login',
  [groups.NEW]: 'signup-profile',
  [groups.ADMIN]: 'registration-list',
  [groups.COACH]: 'coaching-list',
  [groups.COACHEE]: 'coaching-list'
}

const coacheePositions = {
  0: 'Schulleitung',
  1: 'Stellvertretende Schulleitung',
  2: 'Abteilungsleitung',
  3: 'Didaktische Leitung',
  4: 'Lehrkraft'
}

const coacheeSchoolTypes = {
  0: 'Grundschule',
  1: 'Stadtteilschule',
  2: 'Gymnasium',
  3: 'Förderschule',
  4: 'Berufliche Schule'
}

const coachingEstimates = [
  {
    value: 4,
    label: '4 Stunden'
  },
  {
    value: 6,
    label: '6 Stunden'
  },
  {
    value: 8,
    label: '8 Stunden'
  },
  {
    value: 12,
    label: '12 Stunden'
  }
]

const coachingTypes = [
  {
    value: 0,
    label: 'Einzel-Coaching'
  },
  {
    value: 1,
    label: 'Gruppen-Coaching'
  },
  {
    value: 2,
    label: 'Tandem-Coaching'
  }
]

const coachingFinishReasons = {
  0: 'Coaching-Anlass besteht nicht mehr (Problem gelöst)',
  1: 'Coaching-Prozess planmäßig beendet',
  2: 'Fortsetzung erscheint nicht sinnvoll (Bitte begründen)'
}

export default {
  status,
  sessionStatus,
  coachingStatus,
  groups,
  defaultRoute,
  coacheePositions,
  coacheeSchoolTypes,
  coachingEstimates,
  coachingTypes,
  coachingFinishReasons
}
